<style scoped>
[contenteditable]:focus {
  outline: 0px solid transparent;
}

.tab-sheet {
  font-size: 10px;
  border-top: 0.5px solid #ccc;
  border-right: 0.5px solid #ccc;
  width: 100%;
  cursor: pointer;
}

.tab-sheet.active {
  border-top: 0;
}

.tab-sheet .text {
  padding: 5px 20px 5px 20px;
}

.bottom-nav {
  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 0;
  float: left;
  width: 100%;
  background-color: #fff;
}

.bottom-nav div {
  display: block;
  float: left;
  width: auto;
  cursor: pointer;
}

/* .spread-sheet {
  margin-bottom: 30px;
} */

.sticky-menu {
  position: fixed;
  left: 0px;
  top: 0px;
  width: auto;
  z-index: 80;
  height: 45px;
  border-bottom: 0px solid #ccc;
  background-color: #fff;
}

.menu-container {
  position: fixed;
  left: 50px;
  top: 64px;
  width: 500px;
  height: 100%;
  z-index: 10000;
  background-color: rgba(255, 255, 255, 0.9);
  border-right: 0px solid #ccc;
  font-size: 10px;
}

.menu-container .v-input {
  font-size: 10px !important;
}

.canvas-inner {
  height: inherit;
  width: 100%;
  /**background-image: linear-gradient(-225deg, #231557 0%, #44107A 29%, #FF1361 67%, #FFF800 100%);**/
  overflow: hidden;
}

.vue-grid-item {
  /**outline: 1px dashed rgba(170, 170, 170, 0.7);**/
  outline-offset: 0px;
}

.vue-grid-item:hover {
  outline: 0px solid #3b97e3 !important;
}

.layer-editor {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.layer-editor.active {
  border: 0px solid #ccc;
}
</style>
<style>
.editable-layout .layer {
  border: 1px dashed #ccc !important;
}
.dashboard-edit-mode aside {
  margin-top: 50px !important;
}
.dashboard-edit-mode .taybull-layout-toolbar.v-toolbar {
  margin-top: 50px !important;
}

</style>
<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ text }}
      <v-btn color="pink" flat @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-layout row justify-center>
      <v-dialog v-model="dialogDeleteDashboard" max-width="50%">
        <v-card>
          <v-card-title class="headline"
            >Do you want to delete dashboard : {{ chart.name }}?</v-card-title
          >

          <v-card-text> Click Yes to proceed. </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="dialogDeleteDashboard = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="
                aDelete(chart);
                dialogDeleteDashboard = false;
              "
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogImport" max-width="50%">
        <v-card>
          <v-card-title class="headline"
            >Load Dashboard From File</v-card-title
          >

          <v-card-text> 
            <!-- <v-btn small color="" dark @click="$refs.importFiles.click()"> Click To Add Files </v-btn> -->
            <input type="file" accept="application/json" ref="importFiles" style="display: block" @change="onImportFileChange" label="Click To Add Files" multiple>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="dialogImport = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="green darken-1"
              flat="flat"
              :loading="importingDialog"
              @click="
                importDashboard();
              "
            >
              Import
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="dialogDeleteProject" max-width="50%">
        <v-card>
          <v-card-title class="headline"
            >Do you want to this project ?</v-card-title
          >

          <v-card-text>
            This will delete all worksheets and dashboards. Click Yes to
            proceed.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              flat="flat"
              @click="dialogDeleteProject = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click="
                deleteProject();
                dialogDeleteProject = false;
              "
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-dialog fullscreen v-model="loading" full-width>
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-layout justify-center align-center>
          <img
            src="https://taybull-public.s3-eu-west-1.amazonaws.com/lg.hexagon-grid-loader.gif"
          />
        </v-layout>
      </v-container>
    </v-dialog>

    <!-- <v-dialog v-if="subChart.hasDialog" hide-overlay v-model="subChartDialog" v-bind:persistent="true" width="800px" class="bg">
     <v-toolbar>
    <v-btn color="pink" fab dark small absolute middle right @click="mCloseSubChart();">
      <v-icon>close</v-icon>
    </v-btn>
    <v-btn color="pink" fab dark small absolute bottom left @click="mCloseSubChart();">
      <v-icon>close</v-icon>
    </v-btn>
    </v-toolbar> -->
    <v-dialog
      v-if="subChart.hasDialog"
      :fullscreen="dialogFullscreen"
      :hide-overlay="dialogFullscreen"
      v-model="subChartDialog"
      v-bind:persistent="true"
      :width="dialogFullscreen ? '90%' : '800px'"
      :max-height="dialogFullscreen ? '100%' : '80%'"
      class="bg"
    >
      <v-toolbar v-if="!dialogFullscreen">
        <h1 class="pt-2">{{ dialogTitle }}</h1>
        <v-btn
          color="pink"
          fab
          dark
          small
          absolute
          middle
          right
          @click="mCloseSubChart()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-btn
        v-if="dialogFullscreen"
        color="pink"
        fab
        dark
        small
        absolute
        middle
        right
        @click="mCloseSubChart()"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <TaybullLayout
        :chart="subChart.chartData.expandToPageChart"
        :mode="'view'"
      />
    </v-dialog>
    <div ref="printMe">
      <board-menu style="position: fixed; top: 100px; left: 100px; z-index: 100"/>
      <v-container
        fluid
        fill-height
        class="spread-sheet dashboard-edit-mode"
        style="
          padding-top: 0px;
          padding-left: 0px;
          padding-right: 0px;
          overflow-y: auto;
          background-color: #fff;
        "
      >
        <v-layout class="mb-2" row wrap justify-start align-left text-xs-left>
          <div
            class="sticky-menu"
            v-if="chart && chart.layout && chart.layout.grids"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="grey" v-on="on" v-on:click="aAddGrid()">
                  <v-icon>add</v-icon>&nbsp;&nbsp;
                </v-btn>
              </template>
              <span>Add Chart</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  color="indigo"
                  v-on="on"
                  v-on:click="
                    aUpdate(chart);
                    notify('Dashboard Saved');
                  "
                >
                  &nbsp;&nbsp; Save &nbsp;&nbsp; <v-icon>save</v-icon>
                </v-btn>
              </template>
              <span>Save Changes</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  color="indigo"
                  v-on="on"
                  v-on:click="
                    aDownload(chart);
                  "
                >
                  Export &nbsp;&nbsp; <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span>Export</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  color="indigo"
                  v-on="on"
                  v-on:click="dialogImport = true;"
                >
                  Import &nbsp;&nbsp; <v-icon>import_export</v-icon>
                </v-btn>
              </template>
              <span>Export</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  :loading="duplicatingDashboard"
                  color="indigo"
                  v-on="on"
                  v-on:click="duplicateDashboard(chart);"
                >
                  Copy &nbsp;&nbsp; <v-icon>content_copy</v-icon>
                </v-btn>
              </template>
              <span>Copy</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :to="{ name: 'dashboard', params: { projectId: projectId } }"
                  target="_blank"
                >
                  Preview
                  <v-icon right dark>open_in_new</v-icon>
                </v-btn>
              </template>
              <span>Preview</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  :color="editable ? 'blue' : 'grey'"
                  v-on="on"
                  v-on:click="mToggleEditable(editable)"
                >
                  <v-icon>open_with</v-icon>
                </v-btn>
              </template>
              <span
                >{{
                  editable
                    ? "Disable Drag And Resize"
                    : "Activate Drag And Resize"
                }}
              </span>
            </v-tooltip>
            <v-tooltip
              v-if="chart && chart.breakpoints"
              bottom
              v-for="(breakpoint, i) in chart.breakpoints"
              :key="i"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  :color="
                    breakpoint.id == chart.layout.breakpoint ? 'blue' : 'grey'
                  "
                  v-on="on"
                  v-on:click="mSetLayoutUsingBreakpoint(breakpoint)"
                >
                  <v-icon>{{ breakpoint.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ breakpoint.title }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="pink"
                  v-on="on"
                  v-on:click="dialogDeleteDashboard = true"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Delete Dashboard</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  white
                  icon
                  color="pink"
                  v-on="on"
                  v-on:click="dialogDeleteProject = true"
                >
                  <v-icon color="white">delete</v-icon>
                </v-btn>
              </template>
              <span>Delete Project</span>
            </v-tooltip>

            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn flat icon :color="editable ? 'blue' : 'grey'" v-on="on">
                  <v-icon>settings</v-icon>
                </v-btn>
              </template>
              <board-parameter />
            </v-menu>
            <!-- <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-btn flat icon :color="editable ? 'green' : 'grey'" v-on="on">
                  <v-icon>settings</v-icon> 
                </v-btn>
              </template>
              <layout-parameter />
            </v-menu> -->

            <!--
          <chart-parameters v-bind:chart="activeLayer" v-bind:grid="grid" v-bind:mode="mode" />

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn flat icon color="fullscreen ? 'blue' : 'grey'" v-on="on" v-on:click="toggle()">
                <v-icon>fullscreen</v-icon>
              </v-btn>
            </template>
            <span>Fullscreen View</span>
          </v-tooltip>
        -->
          </div>
          <!--
        <div xs12 sm3 fill-height class="menu-container" v-if="showGridMenu">
          <chart-parameters v-bind:chart="activeLayer" />
        </div>
      -->
          <v-flex xs12 sm12 fill-height>
            <div
              class="canvas-inner"
              v-if="chart && chart.layout && chart.layout.grids && display"
            >
              <TaybullLayout
                :chart="chart"
                :mode="editable ? 'editable' : 'view'"
                :class="editable ? 'editable-layout' : ''"
              />
              <!--
            <grid-layout v-if="chart.layout.grids" :layout.sync="chart.layout.grids" :col-num="chart.layout.colNum" :row-height="chart.layout.rowHeight" :is-draggable="editable" :is-resizable="editable" :is-mirrored="false" :vertical-compact="true"
              :margin="chart.layout.margin" :use-css-transforms="true" :responsive="false">
              <grid-item :key="index" v-for="(item, index) in chart.layout.grids" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :item.active="false" @resized="aResized">
                <div :rowHeight="chart.layout.rowHeight" :h="item.h" v-bind:class="[item.id == activeGrid.id ? 'active' : '', 'layer-editor']" v-on:mouseover="aActivateGrid(item, true)">
                  <Layers v-bind:grid="item" mode="edit" />
                </div>
              </grid-item>
            </grid-layout>
            --></div>
            <!--
                <v-card>
                  <chart-scene />
                </v-card>
              -->
          </v-flex>
        </v-layout>
      </v-container>
      <!--<img :src="output">-->
    </div>

    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="headline"
          >We have found no dashboard
        </v-card-title>

        <v-card-text>
          <div>Do you want to auto create a dashboard ?</div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="mSetDialog(false)">
            No
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="
              mSetDialog(false);
              aCreateRandomDashboard();
            "
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <div class="bottom-nav">
      <div
        v-for="item in charts"
        v-bind:key="item.id"
        class="text-xs-left tab-sheet"
        v-on:click="savePrompt(item)" 
        v-bind:class="{ active: item.id === chart.id }"
      >
        <input v-model="item.name" class="text" />
      </div>
      <div class="bottom-icon text-xs-center" v-on:click="aAdd()">
        <v-icon class="text-xs-center">add</v-icon>
      </div>
    </div> -->
  </div>
</template>

<script>
//import Layers from '@/components/Layers.vue';
// const Layers = () => import('@/components/Layers.vue');
// import TaybullLayout from '@/views/Layout.vue';
const TaybullLayout = () => import("@/views/Layout.vue");
import BoardMenu from "@/components/board/menu/chart.vue";
//import VueGridLayout from 'vue-grid-layout';
// const VueGridLayout = () => import('vue-grid-layout');
import { deleteProject } from "@/models/project";
//import ChartParameters from '@/components/charts/Parameter.vue';
// const ChartParameters = () => import('@/components/charts/Parameter.vue');
import dataSources from "@/store/modules/data-sources";
import charts from "@/store/modules/charts";
// import LayoutParameter from "@/components/charts/LayoutParameter.vue";
import BoardParameter from "@/components/charts/BoardParameter.vue";
import {addUsingPayload, updateUsingPayload, duplicate} from '@/models/chart';

function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsText(file);
  })
}


//
import { createNamespacedHelpers } from "vuex";
// const {
//   mapState,
//   mapActions,
//   mapGetters,
//   mapMutations
// } = createNamespacedHelpers('dataSources');
//
//
//
// const dataSourceNamespace = createNamespacedHelpers('dataSources');
const chartNamespace = createNamespacedHelpers("charts");

export default {
  name: "charts",
  data: function () {
    return {
      layoutIds: [{ id: "now" }],
      projectId: null,
      dialogDeleteDashboard: false,
      dialogDeleteProject: false,
      dialogImport: false,
      importingDialog: false,
      duplicatingDashboard: false,
      importData: {
        files: null
      },
      output: null,
      d: true,
      menuOpen: false,
      fullscreen: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 1000,
      text: "Updated",
    };
  },
  components: {
    //GridLayout: VueGridLayout.GridLayout,
    //GridItem: VueGridLayout.GridItem,
    //Layers,
    TaybullLayout,
    "board-parameter": BoardParameter,
    "board-menu": BoardMenu,
  },
  computed: {
    // ...dataSourceNamespace.mapState(['dataSources']),
    ...chartNamespace.mapState({
      charts: (state) => state.charts,
      dialogFullscreen: (state) => state.fullscreen,
      dialogTitle: (state) => state.dialogTitle,
      display: (state) => state.display,
      dialog: (state) => state.dialog,
      subChartDialog: (state) => state.subChartDialog,
      showGridMenu: (state) => state.showGridMenu,
      chart: (state) => state.chart,
      subChart: (state) => state.subChart,
      activeGrid: (state) => state.activeGrid,
      activeLayer: (state) => state.activeLayer,
      editable: (state) => state.editable,
      loading: (state) => state.loading,
      progressValue: (state) => state.progressValue,
    }),
  },
  methods: {
    ...chartNamespace.mapMutations([
      "mCloseSubChart",
      "mSetLayoutUsingBreakpoint",
      "mToggleGridMenu",
      "mSetDialog",
      "mAdd",
      "mSetProjectId",
      "mSetTypeGroup",
      "mSet",
      "mSetName",
      "mToggleEditable",
    ]),
    ...chartNamespace.mapActions([
      "aCreateRandomDashboard",
      "aAdd",
      "aInit",
      "aUpdate",
      "aSet",
      "aCleanSet",
      "aDelete",
      "aResized",
      "aAddGrid",
      "aActivateGrid",
      "aDownload",
      "aImport"
    ]),
    savePrompt(item) {

      this.aUpdate(this.chart);
      this.aCleanSet(item);
      
      // if(this.chart && item.id === this.chart.id ) {
      //   return;
      // }
      // // if(!this.chart.hasChanged()) {
      // //   this.aCleanSet(item);
      // //   return;
      // // }
      // var r = confirm("Reminder : have you saved your changes ? Click ok to proceed.");
      // // this.aUpdate(chart); 
      // if (r == true) {
      //   this.aCleanSet(item);
      // } else {
      //   // txt = "You pressed Cancel!";
      // }
    }, 
    onImportFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.importData.files = files;
    },
    async duplicateDashboard(chart) {
      this.duplicatingDashboard = true;
      await duplicate(chart, charts.length);

      this.duplicatingDashboard = false;
      this.aInit();
    },
    importDashboard: async function() {
      const files = this.importData.files;
      const charts = this.charts;
      this.importingDialog = true;
      for(let i = 0; i < files.length; i++) {
        try {
          const file = files[i];
          const name = file.name.split('.').slice(0, -1).join('.');
          
          const projectId = this.$route.params.projectId;
          const content = JSON.parse(await readFileAsync(file));
          content.projectId = projectId;

          const chart = charts.find(item => item.name == content.name);

          if(chart) {
            // console.log("updateUsingPayload", name);
            await updateUsingPayload(content, chart.id);
          } else {
            // console.log("addUsingPayload", name);
            await addUsingPayload(content);
          }
          // console.log("content " + name + " " + projectId, content);


        } catch(error) {
          console.log("error", error);
        }
      }

      this.importingDialog = false;
      this.dialogImport = false;
      this.aInit();
      


    },
    updateName: function (event) {
      this.mSetName(event.target.innerText);
    },
    updateSubChartId() {
      const subChartId = "subChartId" + new Date().toLocaleTimeString();
      this.layoutIds[0] = { id: subChartId };
      console.log("sunChartId", subChartId);
    },
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    notify(text) {
      this.text = text;
      this.snackbar = true;
    },
    async print() {
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: "dataURL",
      };
      // this.output = await this.$html2canvas(el, options);
    },
    async deleteProject() {
      await deleteProject(this.$route.params.projectId);
      this.$router.push({ name: "projects-home" });
    },
  },
  createRandomDefault() {},
  mounted: function () {
    // console.log("mounted");
    this.updateSubChartId();
    let params = this.$route.params;
    let query = this.$route.query;

    this.projectId = params.projectId;

    this.mSetProjectId(params.projectId);
    this.mSetTypeGroup("board");

    // if(typeof query.create != "undefined" && query.create == 'y') {
    //   // this.aCreateRandomDashboard();
    // } else {
    //
    // }

    // console.log("initialise charts");
    this.aInit();

    const resize = this.aResized;
    setTimeout(function () {
      resize();
    }, 1000);
  },
  beforeCreate: function () {
    // this.$store.registerModule('dataSources', dataSources);
    if (typeof this.$store.state["dataSources"] == "undefined") {
      this.$store.registerModule("dataSources", dataSources);
    }
    if (typeof this.$store.state["charts"] == "undefined") {
      this.$store.registerModule("charts", charts);
    }
    // this.$store.registerModule('charts', charts);
  },
  beforeDestroy() {
    //this.$store.unregisterModule('charts');
    //this.$store.unregisterModule('dataSources');
  },
};
</script>
